import { Controller } from '@hotwired/stimulus'

export default class ReloadableFrameController extends Controller {
  static targets = ['frame', 'mobileFrame'];

  connect() {
    if (this.hasMobileFrameTarget) {
      this.syncMobileFrame = () => {
        this.mobileFrameTarget.innerHTML = this.frameTarget.innerHTML;
      };
      this.frameTarget.addEventListener('turbo:frame-load', this.syncMobileFrame);
    }
  }

  disconnect() {
    if (this.syncMobileFrame) {
      this.frameTarget.removeEventListener('turbo:frame-load', this.syncMobileFrame);
      this.syncMobileFrame = null;
    }
  }

  reload() {
    if (this.frameTarget.src) {
      this.frameTarget.reload();
    } else {
      this.frameTarget.src = this.frameTarget.dataset.src;
    }
  }
}
